import { useEffect, useRef, useState } from 'react';
import { EquipmentDmgFilterType } from '@/entities/equipment';
import { useLocalStorageState } from '../local-storage.hooks';
import debounce from 'lodash/debounce';
import { DamageLocalStorage } from '@/entities/damage';

interface DamageFilterProps {
  setCurrentPage: (page: number) => void;
}

export const useDamageFilter = ({ setCurrentPage }: DamageFilterProps) => {
  const [debouncedFilter, setDebouncedFilter] =
    useState<EquipmentDmgFilterType>({
      key: '',
    });
  const filtersEmptyRef = useRef<boolean>(true);

  /**
   * === Filter section ===
   */
  const [key, setKey] = useLocalStorageState({
    key: DamageLocalStorage.KEY,
    removeOnClose: true,
  });

  const [status, setStatus] = useLocalStorageState({
    key: DamageLocalStorage.STATUS,
    removeOnClose: true,
  });

  useEffect(() => {
    setDebouncedFilter((prev) => ({
      ...prev,
      key: key || '',
      status,
    }));

    filtersEmptyRef.current = !key && !status;
  }, [key, status]);

  const debounceFilterUpdate = (value: string) => {
    setKey(value);
    debounce((value: string) => {
      setDebouncedFilter((prev) => ({ ...prev, key: value }));
    }, 1000);
  };

  const searchByStatus = (value: string) => {
    setStatus(value);
    setDebouncedFilter((prev) => ({ ...prev, status: value }));
  };

  const clearFilters = () => {
    setKey('');
    setStatus('');
    setCurrentPage(1);
  };
  /**
   * === END OF Filter section ===
   */

  return {
    debouncedFilter,
    filtersEmpty: filtersEmptyRef.current,
    clearFilters,
    key,
    status,
    debounceFilterUpdate,
    searchByStatus,
  };
};
